module.exports = __webpack_public_path__ + "static/favicon-64x64-cff4c1246bc90672cd1597bb6b017e37.png";